module.exports = __webpack_public_path__ + "officialStatic/img/productSw.ab8c6d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/productSw.png
// module id = l80T
// module chunks = 0